import { clx, Label } from '@medusajs/ui';
import type { ComponentProps } from 'react';

export enum OrderLabelKind {
  Processing = 'Processing',
  Done = 'Done',
  Initial = 'Initial',
  Other = 'Other',
}

type OrderLabelProps = Omit<ComponentProps<typeof Label>, 'size'> & {
  kind: OrderLabelKind;
};

export const OrderLabel = ({
  className,
  children,
  kind,
  ...props
}: OrderLabelProps) => (
  <Label
    {...props}
    size="base"
    className={clx(
      'inline-flex h-[30px] w-[86px] items-center justify-center rounded-md',
      {
        'bg-orange-30_op10 text-orange-30': kind === OrderLabelKind.Processing,
        'bg-green-20_op10 text-green-20': kind === OrderLabelKind.Done,
        'bg-white-40 text-black-10': kind === OrderLabelKind.Initial,
        'bg-purple-30_op10 text-purple-10': kind === OrderLabelKind.Other,
      },
      className
    )}
  >
    {children}
  </Label>
);
